import { MessageDto } from './message-dto';
import { RBConvert } from '@lfw/roesberg';

export class Message {
  public id = '';
  public lines: string[] = [];
  public timeStamp = '';

  public static fromDto(dto: MessageDto): Message {
    const msg = new Message();
    msg.id = dto.id;
    msg.lines = dto.lines;
    msg.timeStamp = RBConvert.jsonUTCStringToString(dto.timeStamp);
    return msg;
  }
}
